var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.185,
    height: 16.872,
    viewBox: "0 0 15.185 16.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Calendar",
    "data-name": "Iconly/Bulk/Calendar",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M10.851,10.75H4.325A4.344,4.344,0,0,1,1.172,9.586,4.342,4.342,0,0,1,0,6.422V0H15.185V6.473A4,4,0,0,1,10.851,10.75ZM11,6.018a.7.7,0,0,0-.683.716.7.7,0,1,0,.692-.716ZM7.576,6.008h0a.721.721,0,0,0-.683.726.694.694,0,0,0,.685.676h.031a.7.7,0,0,0-.033-1.4Zm-3.433,0h0a.721.721,0,0,0-.683.726.694.694,0,0,0,.685.676h.031a.681.681,0,0,0,.476-.223.694.694,0,0,0,.182-.5.687.687,0,0,0-.692-.676ZM7.576,2.946h0a.721.721,0,0,0-.683.727.693.693,0,0,0,.684.674h.033a.694.694,0,0,0,.659-.725.687.687,0,0,0-.692-.675Zm-3.425,0h0a.721.721,0,0,0-.683.727.693.693,0,0,0,.684.674h.033a.681.681,0,0,0,.476-.223.694.694,0,0,0,.182-.5.687.687,0,0,0-.692-.675Zm6.859.01a.7.7,0,0,0-.683.709v.008a.685.685,0,0,0,.691.674h.017a.667.667,0,0,0,.47-.208.706.706,0,0,0,.2-.508.7.7,0,0,0-.692-.675Z",
    transform: "translate(0 6.122)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M643,872.855a13.369,13.369,0,0,1,.131-1.794,3.873,3.873,0,0,1,3.7-3.071h7.517a3.914,3.914,0,0,1,3.7,3.071,13.371,13.371,0,0,1,.13,1.794Z",
    transform: "translate(-643 -866.733)",
    fill: "#cea95a",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M648.186,870.372a.63.63,0,0,0,.642-.649V867.15a.642.642,0,1,0-1.283,0v2.572A.63.63,0,0,0,648.186,870.372Z",
    transform: "translate(-643.71 -866.5)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M655.576,870.372a.635.635,0,0,0,.642-.649V867.15a.642.642,0,1,0-1.283,0v2.572A.63.63,0,0,0,655.576,870.372Z",
    transform: "translate(-644.866 -866.5)",
    fill: "#cea95a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d8a84f207b6edd0c87b6067a2e10f936.svg";
export { ForwardRef as ReactComponent };